import { render, staticRenderFns } from "./DeterminePlacement.vue?vue&type=template&id=10239d70"
import script from "./DeterminePlacement.vue?vue&type=script&lang=js"
export * from "./DeterminePlacement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports